import { z } from 'zod';

export const ReleaseCommitSchema = z.object({
  id: z.string().uuid(),
  short_id: z.string(),
  created_at: z.string(),
  title: z.string(),
  message: z.string(),
  author_name: z.string(),
});

export type ReleaseCommit = z.infer<typeof ReleaseCommitSchema>;

export const ReleaseSchema = z.object({
  name: z.string(),
  tag_name: z.string(),
  commit: ReleaseCommitSchema,
  description: z.string(),
  created_at: z.string(),
  released_at: z.string(),
});

export type Release = z.infer<typeof ReleaseSchema>;
